/**
 * 캘린더 렌더 컨트롤러.
 *
 * [data-fw-calendar] 컨테이너의 data-target (ISO / YYYY-MM-DD / ms timestamp) 에서
 * 연·월·결혼일자를 파싱해 tbody 를 채운다.
 *
 * DOM 규약:
 *   <div data-fw-calendar data-target="{{ wedding.date }}">
 *     <div data-fw-calendar-month></div>        // "2026년 1월" 자동 채움
 *     <table>
 *       <thead>...</thead>
 *       <tbody data-fw-calendar-body></tbody>   // <tr><td><div class="cal-cell [wedding]">... 자동 생성
 *     </table>
 *   </div>
 *
 * 셀 마크업: `<div class="cal-cell">` + `<span class="cal-num [cal-sun|cal-sat]">{일}</span>`.
 * wedding 일자는 `.cal-cell.wedding` 클래스 + `<span class="cal-time">{data-wedding-time-label}</span>` 포함.
 * time label 은 컨테이너의 data-wedding-time-label 속성에서 읽고, 미지정 시 data-target 시각을 "오후/오전 h시" 로 포맷.
 */
export const CALENDAR_CONTROLLER_SCRIPT = `
<script data-fw-calendar-controller>
(function () {
  function formatTimeLabel(d) {
    // d 는 KST(UTC+9) 벽시계로 시프트된 Date — getUTC* 로 읽는다
    var h = d.getUTCHours();
    var ampm = h < 12 ? '오전' : '오후';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    var m = d.getUTCMinutes();
    return ampm + ' ' + h12 + '시' + (m > 0 ? ' ' + m + '분' : '');
  }
  function init() {
    var cals = document.querySelectorAll('[data-fw-calendar]');
    for (var ci = 0; ci < cals.length; ci++) {
      var cal = cals[ci];
      if (cal.dataset.fwCalendarInit) continue;
      cal.dataset.fwCalendarInit = '1';
      var raw = cal.getAttribute('data-target');
      if (!raw) continue;
      var ts = /^\\d+$/.test(raw) ? Number(raw) : Date.parse(raw);
      if (isNaN(ts)) continue;
      // 런타임 타임존과 무관하게 KST(UTC+9) 벽시계로 고정 표시
      var d = new Date(ts + 9 * 60 * 60 * 1000);
      var year = d.getUTCFullYear();
      var month = d.getUTCMonth();
      var weddingDay = d.getUTCDate();
      var monthEl = cal.querySelector('[data-fw-calendar-month]');
      if (monthEl) monthEl.textContent = year + '년 ' + (month + 1) + '월';
      var body = cal.querySelector('[data-fw-calendar-body]');
      if (!body) continue;
      var firstDow = new Date(year, month, 1).getDay();
      var lastDate = new Date(year, month + 1, 0).getDate();
      var cells = [];
      for (var i = 0; i < firstDow; i++) cells.push(null);
      for (var dd = 1; dd <= lastDate; dd++) cells.push(dd);
      while (cells.length % 7 !== 0) cells.push(null);
      var timeLabel = cal.getAttribute('data-wedding-time-label') || formatTimeLabel(d);
      while (body.firstChild) body.removeChild(body.firstChild);
      for (var r = 0; r < cells.length; r += 7) {
        var tr = document.createElement('tr');
        for (var j = 0; j < 7; j++) {
          var td = document.createElement('td');
          // 선택 날짜 셀만 시간 라벨이 붙어 높이가 커지므로, 모든 셀을 상단 정렬로
          // 통일해 날짜 숫자의 baseline 을 같은 행끼리 맞춘다 (CSS 의 middle/center 를 인라인으로 덮어씀).
          td.style.verticalAlign = 'top';
          var v = cells[r + j];
          if (v === null) { tr.appendChild(td); continue; }
          var cell = document.createElement('div');
          cell.className = 'cal-cell';
          cell.style.justifyContent = 'flex-start';
          if (v === weddingDay) cell.classList.add('wedding');
          var num = document.createElement('span');
          num.className = 'cal-num';
          if (v !== weddingDay) {
            if (j === 0) num.classList.add('cal-sun');
            if (j === 6) num.classList.add('cal-sat');
          }
          num.textContent = String(v);
          cell.appendChild(num);
          if (v === weddingDay && timeLabel) {
            var tl = document.createElement('span');
            tl.className = 'cal-time';
            tl.style.whiteSpace = 'nowrap';
            tl.textContent = timeLabel;
            cell.appendChild(tl);
          }
          td.appendChild(cell);
          tr.appendChild(td);
        }
        body.appendChild(tr);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
</script>
`;
//# sourceMappingURL=calendar.js.map